import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import Process from "./sections/Process";
import Consulting from "./sections/Consulting";
import KnowledgeSpotlight from "./sections/KnowledgeSpotlight";
import CallToAction from "./sections/CallToAction";
import FinancialAssessment from "./sections/FinancialAssessment";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <FinancialAssessment />
      <Process />
      <Consulting />
      <KnowledgeSpotlight />
      <CallToAction />
      <Footer />
    </div>;
}